/* ──────────────────────────────────────────────────────────────────────────
   The currencies a price can be in. AUD, USD, PHP and EUR first, the four the
   team pays in (Jay, 2026-10-21), then the rest alphabetically. Only the ones
   the exchange rate source publishes, so every payment can be added to the
   monthly AUD total (server/rates.ts).
   ────────────────────────────────────────────────────────────────────────── */

export const TOP_CURRENCIES = ["AUD", "USD", "PHP", "EUR"] as const;

export const OTHER_CURRENCIES = [
  "BRL", "CAD", "CHF", "CNY", "CZK", "DKK", "GBP", "HKD", "HUF", "IDR", "ILS", "INR", "ISK", "JPY", "KRW",
  "MXN", "MYR", "NOK", "NZD", "PLN", "RON", "SEK", "SGD", "THB", "TRY", "ZAR",
] as const;

export const CURRENCIES: readonly string[] = [...TOP_CURRENCIES, ...OTHER_CURRENCIES];

export const isCurrency = (code: string) => CURRENCIES.includes(code);
